import { Record } from 'immutable';
export default class UserAttributes extends Record({
  languageAndLocale: undefined,
  defaultPhoneCountryCode: undefined,
  phoneNumber: undefined,
  twoFactorStatus: undefined,
  unsubscribeLinkType: undefined,
  defaultHome: undefined
}) {}